var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8.98657,
    r: 8,
    fill: "#C60F13"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99804 10.6329C8.54924 10.6329 8.99608 10.186 8.99608 9.63483L8.99608 5.24804C8.99608 4.69684 8.54924 4.25 7.99804 4.25C7.44684 4.25 7 4.69684 7 5.24804L7 9.63483C7 10.186 7.44684 10.6329 7.99804 10.6329Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 12.5721C7 13.1234 7.44684 13.5702 7.99804 13.5702H8.00636C8.55756 13.5702 9.00439 13.1234 9.00439 12.5721C9.00439 12.0209 8.55756 11.5741 8.00636 11.5741H7.99804C7.44684 11.5741 7 12.0209 7 12.5721Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/ErrorIcon.6a98fe5df19461580ea4f5635e37aac7.svg";
export { ForwardRef as ReactComponent };